import { BaseBusinessLogItem, BusinessLogItemProps } from './BaseBusinessLogItem';
import { MetaInformation } from './MetaInformation';

export const DefaultBusinessLogItem = ({ item, virtual }: BusinessLogItemProps) => {
  const { actorId, actorVariant, createdAt } = item;

  return (
    <BaseBusinessLogItem
      item={item}
      virtual={virtual}
      secondary={<MetaInformation actorId={actorId} actorVariant={actorVariant} createdAt={createdAt} />}
    />
  );
};
